import { ApiMembershipProduct } from "@tytapp/api";

export class MembershipProduct extends ApiMembershipProduct {

}